module.exports = __webpack_public_path__ + "static/img/5-EN.022c3e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/5-EN.png
// module id = rj5Z
// module chunks = 1